import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable'
import { Page } from '../../Pages'
import { ShowIfRole } from '../../auth/AuthGuard'

const WaterMetersTablePage = Loadable(lazy(() => import('./WaterMetersTable')))

const waterMetersRoutes = [
	{
		path: Page.water_maters.path,
		element: (
			<ShowIfRole role={Page.water_maters.auth}>
				<WaterMetersTablePage />
			</ShowIfRole>
		),
		auth: Page.water_maters.auth
	}
]

export default waterMetersRoutes
